import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { bindActionCreators } from 'redux';

// core components
import Typography from '@material-ui/core/Typography';
import Checkbox from '@material-ui/core/Checkbox';
import Button from '@material-ui/core/Button';
import Grid from "@material-ui/core/Grid";
import GridItem from "../../../views/GridItem";
import GridContainer from "../../../views/GridContainer";
import Table from "../../../views/Table";
import Card from "../../../views/Card";
import CardHeader from "../../../views/CardHeader";
import CardBody from "../../../views/CardBody";
import { withSnackbar } from 'notistack';
import NewSite from './NewSite'
import { styles } from './styles';
import ConfirmDialog from './ConfirmDialog'
import Apis from '../../../../utils/Apis'
import Workbook from 'react-excel-workbook'
import Edit from './Edit'

class SiteManage extends Component {
    state = {
        sites_count: 0,
        pageNumber: 1,
        sites: [],
        temp_page: [],
        export_sites: [],
        isLoading: false,
        open_register: false,
        open_edit: false,
        id: '',
        name: '',
    }

    componentWillMount() {
        const { pageNumber } = this.state;
        this.getsites(pageNumber);
    }
    getsites = async (pageNumber) => {
        this.setState({ isLoading: true });
        try {
            this.setState({ isLoading_country_ip: true });
            let response = await Apis.getSites();
            let sites = response.data;
            const { classes } = this.props;
            let temp = [];
            let temp_sites = [];
            var index = 0;
            for (let i = 0; i < sites.length; i++) {
                let site_id = sites[i]['_id'];
                let name = sites[i]['name'];
                let active = sites[i]['active'];
                temp = [...temp,
                [

                    <Typography noWrap className={classes.typographyContent}>{i + 1}</Typography>,
                    <Typography noWrap className={classes.typographyContent}>{name}</Typography>,
                    this.operationViewActive(site_id, active),
                    this.operationViewEdit(site_id, name),
                ]
                ];
                temp_sites = [
                    ...temp_sites,
                    {No: i + 1, Name: name, Active: active}
                ];
            }

            const { pageNumber } = this.state;
            let temp_page = [];
            temp_page = temp;

            this.setState({ pageNumber: pageNumber, isLoading: false, sites_count: sites.length, sites: temp, temp_page: temp_page, export_sites: temp_sites })


        }
        catch (error) {
            let messageProperty = Object.getOwnPropertyDescriptor(error, 'message');
            this.setState({ isLoading: false });
            this.props.enqueueSnackbar(messageProperty.value, {
                variant: 'error',
            });
        }
    }
    operationViewActive = (site_id, active) => {
        return (
            <Grid container>
                {this.viewCheckActive(site_id, active)}
            </Grid>
        )
    }
    viewCheckActive = (site_id, active) => {
        const { classes } = this.props;
        return (
            <Checkbox
                checked={active}
                onClick={this.onActionActive(site_id)}
                value="site_id"
                color="primary"
            />
        );
    }
    onActionActive = site_id => event => {
        Apis.updateSite(site_id, event.target.checked)
            .then(res => {
                const { pageNumber } = this.state;
                this.getsites(pageNumber);
            })
            .catch(err => {
            })
    }
    operationViewEdit = (site_id, name) => {
        return (
            <Grid container>
                {this.viewButtonEdit(site_id, name)}
            </Grid>
        )
    }
    viewButtonEdit = (site_id, name) => {
        const { classes } = this.props;
        return (
            <Button color="secondary" className={classes.viewButton} disableRipple disableFocusRipple onClick={() => this.onActionViewEdit(site_id, name)} >
                {'Edit'}
            </Button>
        );
    }
    onActionViewEdit = (site_id, name) => {
        this.setState({ open_edit: true, id: site_id, name: name});
    }
    onCloseEdit = () => {
        this.setState({open_edit: false });
    }
    onDoneEdit = () => {
        this.setState({open_edit: false });
        const { pageNumber } = this.state;
        this.getsites(pageNumber);
    }
    onAlertMessage = (type, message) => {
        this.props.enqueueSnackbar(message, {
            variant: type,
        });
    }
    // action for pagination
    handleChangePage = (event, page) => {
        const { pageNumber, sites } = this.state;
        this.setState({
            pageNumber: page + 1,
        });
    }
    createNew = () => {
        const { requesting } = this.props;
        if (requesting) {
            return;
        }
        this.setState({ open_register: true });
    }
    onCloseRegister = () => {
        this.setState({ open_register: false });
    }
    onDoneRegister = () => {
        this.setState({ open_register: false });
        const { pageNumber } = this.state;
        this.getsites(pageNumber);
    }
    onAlertMessage = (type, message) => {
        this.props.enqueueSnackbar(message, {
            variant: type,
        });
    }
    render() {
        const { classes } = this.props;
        const { sites_count, pageNumber, temp_page, isLoading, export_sites } = this.state;
        return (
            <div container>
                <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                        <Card>
                            <CardHeader color="primary">
                                <h4 className={classes.cardTitleWhite}>Sites</h4>
                            </CardHeader>
                            <CardBody>
                                <Table
                                    tableHeaderColor="black"
                                    tableHead={[<b>No</b>, <b>Name</b>, <b>Active</b>, <b>Action</b>]}
                                    tableData={temp_page}
                                    handleChangePage={this.handleChangePage}
                                    containerHeight={620}
                                    totalCount={temp_page.length}
                                    rowsPerPage={10}
                                    page={pageNumber}
                                    isLoading={isLoading}
                                />
                                <Grid container xs={12} sm={12} md={12}>
                                    <Grid container direction="column" justify="center" alignItems="stretch" xs={12} sm={12} md={9}>
                                    </Grid>
                                    <Grid container direction="column" justify="center" alignItems="stretch" xs={12} sm={12} md={1}>
                                        <Workbook filename="sites.xlsx" element={<Button variant="contained" color="primary" className={classes.btnUpdate} disableRipple>Export</Button>}>
                                            <Workbook.Sheet data={export_sites} name="Sheet A">
                                                <Workbook.Column label="No" value="No" />
                                                <Workbook.Column label="Name" value="Name" />
                                                <Workbook.Column label="Active" value="Active" />
                                            </Workbook.Sheet>
                                        </Workbook>
                                    </Grid>
                                    <Grid container direction="column" justify="center" alignItems="stretch" xs={12} sm={12} md={2}>
                                        <Button variant="contained" color="primary" className={classes.btnUpdate} disableRipple onClick={this.createNew}>
                                            New Site
                                    </Button>
                                    </Grid>
                                </Grid>
                            </CardBody>
                        </Card>
                    </GridItem>
                </GridContainer>
                <NewSite
                    onClose={this.onCloseRegister}
                    onAlertMessage={this.onAlertMessage}
                    open={this.state.open_register}
                    onDoneRegister={this.onDoneRegister} />
                {this.state.open_edit && <Edit
                    onClose={this.onCloseEdit}
                    open={this.state.open_edit}
                    id={this.state.id}
                    name={this.state.name}
                    onDoneEdit={this.onDoneEdit}
                    onAlertMessage={this.onAlertMessage} />}
            </div>
        );
    }
}

SiteManage.propTypes = {
    classes: PropTypes.object.isRequired
};

let mapStateToProps = (state) => {
    return {
        email: state.auth.email,
        requesting: state.auth.requesting,
    };
}
export default withStyles(styles)(connect(mapStateToProps, null)(withSnackbar(SiteManage)));